import React from 'react';
import PropTypes from 'prop-types';
import { Cloud, Lighting, Drops, Icon, Patchy } from './components';
import Sunny from './Sunny';

var Rain = function Rain(_ref) {
  var lighting = _ref.lighting,
      patchy = _ref.patchy,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(Icon, {
    size: size
  }, /*#__PURE__*/React.createElement(Cloud, null), patchy && /*#__PURE__*/React.createElement(Patchy, null, /*#__PURE__*/React.createElement(Sunny, null)), lighting ? /*#__PURE__*/React.createElement(Lighting, null) : /*#__PURE__*/React.createElement(Drops, null));
};

Rain.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Icon size */
  size: PropTypes.number,

  /** Display Bolts */
  lighting: PropTypes.bool,

  /** Display Sun */
  patchy: PropTypes.bool
} : {};
Rain.defaultProps = {
  lighting: false,
  patchy: false,
  size: 1
};
export default Rain;